import { f7, useStore } from 'framework7-react';
import { FC } from 'react';
import { RegisterNewMemberStep2 } from './RegisterNewMemberStep2/RegisterNewMemberStep2';
import { RegisterNewMemberStep4 } from './RegisterNewMemberStep4/RegisterNewMemberStep4';
import style from './RegisterNewMemberStyle.module.css';
import { RegisterNewStaffStep1 } from './RegisterNewStaffStep1/RegisterNewStaffStep1';
import { RegisterQRPageTemplate } from '@/components/uiParts/Template/RegisterQRPageTemplate/RegisterQRPageTemplate';
import { RegisterUserDataType } from '@/config/initialState';
import { paths } from '@/config/paths';
import { store } from '@/config/store';
import { mobileAuthSelectedProcess } from '@/consts/auth';
import { affiliateId } from '@/consts/shop';
import { useMobileAuth } from '@/hooks/api/auth/useMobileAuth';
import { MobileAuthApiParams } from '@/types/api/authApi';
import { storeDispatch } from '@/utils/store';

export const RegisterNewStaff: FC = () => {
  const registerUserData = useStore(
    store,
    'getRegisterUser',
  ) as RegisterUserDataType;
  const { currentStep, step1 } = registerUserData;
  const { authenticateMobile } = useMobileAuth();

  const handleBack = () => {
    if (currentStep > 1) {
      storeDispatch('setRegisterUser', 'registerUser', {
        ...registerUserData,
        currentStep: currentStep - 1,
      });
    } else {
      f7.view.main.router.navigate(
        `${paths.registerQR}?affiliate_id=${
          registerUserData.affiliate_id || affiliateId.DEFAULT
        }`,
        {
          transition: 'push-reverse',
        },
      );
    }
  };

  const handleSkipStep4 = async () => {
    // 会員登録後のSMS認証コードを送信
    const mobileAuthParams: MobileAuthApiParams = {
      phone_no: step1.tel1 + '-' + step1.tel2 + '-' + step1.tel3,
      selected_process: mobileAuthSelectedProcess.register,
      m_customer_id: registerUserData.m_customer_id,
      m_affiliate_id: registerUserData.affiliate_id
        ? String(registerUserData.affiliate_id)
        : undefined,
    };
    await authenticateMobile(mobileAuthParams);
  };

  return (
    <RegisterQRPageTemplate
      title="新規会員登録"
      pageName="RegisterNewMember"
      showNavBack={true}
      handleClickBack={handleBack}
    >
      <div
        className={`${style['page']} ${
          currentStep === 1 ? style['white-page'] : ''
        }`}
      >
        {[1, 2].includes(currentStep) && (
          <div className={style['content']}>
            {currentStep === 1 && <RegisterNewStaffStep1 />}

            {currentStep === 2 && <RegisterNewMemberStep2 />}
          </div>
        )}

        {currentStep === 3 && (
          <RegisterNewMemberStep4 hanldeCancel={handleSkipStep4} />
        )}
      </div>
    </RegisterQRPageTemplate>
  );
};
